import { toast } from "react-toastify"
import axios from "axios"
import authService from "./authService"

const apiHelper = ({ method, path, data = null }) => {
    return new Promise((resolve, reject) => {
        const token = authService.getToken()

        let config = {
            method,
            headers: {
                Authorization: "Bearer " + token,
            },
            maxBodyLength: Infinity,
            url: path,
            data,
        }

        axios
            .request(config)
            .then((res) => {
                // Manually check status code and throw error if >= 400

                if (res.status >= 400) {
                    const errorMessage = res.data?.fa || res.data?.message || "مشکلی به وجود امده است"
                    toast.error(errorMessage)
                    reject({
                        message: errorMessage,
                        status: res.status,
                        data: res.data,
                    })
                    return
                }

                resolve({ data: res.data, status: res?.status })
            })
            .catch((err) => {
                console.error(err)
                console.log("HHH")
                if (err?.response) {
                    console.log(err)
                    const errorMessage =
                        err.response?.data?.fa || err.response?.data?.message || "مشکلی به وجود امده است"
                    toast.error(errorMessage)
                    reject({
                        message: errorMessage,
                        status: err.response.status,
                        data: err.response.data,
                    })
                } else {
                    const errorMessage = err?.message || "خطا در اتصال به سرور"
                    toast.error(errorMessage)
                    reject({
                        message: errorMessage,
                        status: err?.errno || 0,
                    })
                }
            })
    })
}

export default apiHelper
